import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.6314 4.35571C19.1057 4.82999 19.1057 5.60021 18.6314 6.07449L8.91821 15.7877C8.44393 16.262 7.67371 16.262 7.19943 15.7877L2.34283 10.9311C1.86855 10.4568 1.86855 9.68659 2.34283 9.21231C2.81711 8.73803 3.58733 8.73803 4.06161 9.21231L8.06072 13.2076L16.9164 4.35571C17.3907 3.88143 18.1609 3.88143 18.6352 4.35571H18.6314Z",
		fill: "#0D2976"
	})
});
export default SvgCheck;
